import {handleActions} from 'redux-actions';

import {VIEW_TEAMS_LOADING_STATE} from '/enum/myTeams.enum';
import {
  GET_VIEW_TEAMS,
  RESET_MY_TEAMS_INFO,
  RESET_VIEW_TEAMS_INFO,
  SET_IS_VIEW_TEAM,
  SET_SCREEN_CONTEXT,
  SET_SELECTED_TAB,
  UPDATE_MY_TEAMS_FILTER,
} from '/redux/action/myTeams.action';
import {withPayload} from '/util/reducer.util';

import {MyTeamsFilters} from '../../component/screen/report/MyTeamsReport/util/myTeamsFilterDomain.util';

import resetMyTeamsInfo from './myTeams/resetMyTeamsInfo';
import resetViewTeamsInfo from './myTeams/resetViewTeamsInfo';
import viewTeams from './myTeams/viewTeams';
import viewTeamsStateReducer from './myTeams/viewTeamsState';

interface MyTeamsState {
  viewTeams: any;
  screenContext: string;
  isViewTeam: boolean;
  filters: MyTeamsFilters;
  coachId: string;
  reportFilterCount: number;
  reportCountAllOrg: number;
  selectedTab: string;
}

const initialState: MyTeamsState = {
  viewTeams: [],
  screenContext: '',
  isViewTeam: false,
  filters: {},
  coachId: '',
  reportFilterCount: 0,
  reportCountAllOrg: 0,
  selectedTab: 'my-teams',
};

export default handleActions(
  {
    [GET_VIEW_TEAMS]: withPayload(viewTeams),
    [VIEW_TEAMS_LOADING_STATE]: withPayload(viewTeamsStateReducer),
    [RESET_MY_TEAMS_INFO]: withPayload(resetMyTeamsInfo),
    [SET_SCREEN_CONTEXT]: (state, {payload}) => ({
      ...state,
      screenContext: payload,
    }),
    [SET_IS_VIEW_TEAM]: (state, {payload}) => ({
      ...state,
      isViewTeam: payload,
    }),
    [SET_SELECTED_TAB]: (state, {payload}) => ({
      ...state,
      selectedTab: payload,
    }),
    [RESET_VIEW_TEAMS_INFO]: withPayload(resetViewTeamsInfo),
    [UPDATE_MY_TEAMS_FILTER]: (state, {payload}) => ({
      ...state,
      filters: {
        ...payload,
      },
    }),
  },
  initialState,
);
